import { Injectable } from "@angular/core";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { IContractedCategory } from "src/app/Models/Interface/Client/Contract/ContractedItems/contracted-category";
import { ContractedItemsService } from "src/app/Services/Client/Contract/contracted-items.service";

@Injectable({
  providedIn: "root",
})
export class ContractedCategoriesResolver
  implements Resolve<IContractedCategory[]>
{
  constructor(private contractedItemsService: ContractedItemsService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IContractedCategory[]> {
    // @ts-ignore
    let accountId = +route.paramMap.get("accountId");
    return this.contractedItemsService.getCategories(accountId);
  }
}
